import React, { useState, useEffect } from 'react';
import { useLocation, Route, Routes } from 'react-router-dom';

//Components
import Sidebar from '../components/Sidebar/Sidebar';
import NavBarAdmin from '../components/Navbars/NavBarAdmin';

//Assets
import "../assets/css/admin.css";
import { faHome } from '@fortawesome/free-solid-svg-icons';

//Routes
import routes from '../routes/views.routes';

//Api
import usuario_api from '../api/usuario_api';
import { showMessage } from '../helpers/message';

//Context
import { useAuth } from '../context/auth';

export default function Admin() {
    const { setLoading } = useAuth();
    const location = useLocation();

    //Estado de controle de visualização da sidebar
    const [sidebarOpen, setSidebarOpen] = useState(true);

    //Estado de controle de todas as rotas do ambiente admin 
    const [routesAdmin, setRoutesAdmin] = useState([]);

    //Estado de controle das rotas da sidebar
    const [routesSidebar, setRoutesSidebar] = useState([]);

    //Estado de controle do icone e do texto que serão exibidos na navbar
    const [icon, setIcon] = useState();
    const [brand, setBrand] = useState();

    //Estado de controle de funcionalidades do usuario
    const [funcionalidades, setFuncionalidades] = useState([]);
    // Busca o icone e o texto da rota ativa
    function getIconAndBrand(_routesSidebar) {
        if (_routesSidebar.length > 0) {
            _routesSidebar = _routesSidebar.map((prop, key) => {

                if (!prop.submenus && window.location.href.indexOf(prop.layout + "/" + prop.path) !== -1) {
                    if (prop.icon && prop.name) {
                        setIcon(prop.icon);
                        setBrand(prop.name);
                    }
                    prop.active = true;
                } else if (prop.submenus) {
                    prop.submenus.map(value => {
                        if (window.location.href.indexOf(value.layout + "/" + value.path) !== -1) {
                            if (value.icon && value.name) {
                                setIcon(value.icon);
                                setBrand(value.name);
                            }
                            value.active = true;
                        } else {
                            value.active = false;
                        }
                        return value;
                    })
                } else {
                    prop.active = false;
                }

                return prop;
            });
            setRoutesSidebar(_routesSidebar);
        }

    }
    function getRoutes() {
        setLoading(true);
        usuario_api.getFuncionalidades().then(response => {
            let _routes = [];  //Carrega as rotas de navegação interna
            let _routesSidebar = []; //Carrega os itens do menu
            routes.filter(f => f.layout == "/admin").map(route => {
                if (!route.submenus) {
                    if (response.data.some(x => x.codigoFuncionalidade == route.codigoFuncionalidade) || (route.modulo && route.modulo.some(x => x == "Restrito"))) {

                        if (route.sidebar)
                            _routesSidebar.push({
                                layout: route.layout,
                                path: route.path,
                                permissoes: response.data.filter(x => x.codigoFuncionalidade == route.codigoFuncionalidade),
                                component: route.component,
                                name: route.name,
                                icon: route.icon
                            });

                        _routes.push({
                            layout: route.layout,
                            path: route.path,
                            permissoes: response.data.filter(x => x.codigoFuncionalidade == route.codigoFuncionalidade),
                            component: route.component,
                            name: route.name,
                            icon: route.icon
                        })
                    }
                }
                else {
                    if (route.submenus.some(x => response.data.some(y => y.codigoFuncionalidade == x.codigoFuncionalidade))) {
                        let _submenus = [...route.submenus.filter(x => response.data.some(y => y.codigoFuncionalidade == x.codigoFuncionalidade))];
                        if (_submenus.length > 0 && route.sidebar) {
                            let _menu = route;
                            _menu.submenus = _submenus;
                            _routesSidebar.push(_menu);
                        }

                        route.submenus.map((subroute, subkey) => {
                            if (response.data.some(x => x.codigoFuncionalidade == subroute.codigoFuncionalidade)) {
                                _routes.push({
                                    layout: route.layout,
                                    path: subroute.path,
                                    permissoes: response.data.filter(x => x.codigoFuncionalidade == subroute.codigoFuncionalidade),
                                    component: subroute.component,
                                    name: subroute.name,
                                    icon: subroute.icon
                                })
                            }

                        });
                    }
                }

            });
            setRoutesAdmin(_routes);
            setRoutesSidebar(_routesSidebar);
            getIconAndBrand(_routesSidebar);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        getRoutes();
    }, []);

    // Mudança de Rota
    useEffect(() => {
        getIconAndBrand(routesSidebar);
    }, [location.pathname]);
    return (
        <div className='mainContainerAdmin'>
            <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} routes={routesSidebar} />
            <div className={`divConteudoAdmin ${sidebarOpen ? "isOpen" : ""}`}>
                <NavBarAdmin icon={icon} brand={brand} userMenu={true} />
                <div className='mx-5 my-3'>
                    <Routes >
                        {routesAdmin.map((prop, key) => {
                            const Screen = prop.component;
                            if (prop.layout !== "/admin") {
                                return <></>;
                            } else {
                                return (
                                    <Route
                                        path={prop.path}
                                        element={<Screen permissoes={prop.permissoes} />}
                                        key={key}
                                    />
                                );
                            }
                        })}
                    </Routes>
                </div>
            </div>
        </div>
    )
}